import Register from '../../features/auth/register'

export const RegisterPage = () => {
    return (
        <div>
            <Register />
        </div>
    )
}
